<template>
  <v-col style="max-width: 900px">
    <h1 class="primary--text">
      {{ $t('documentation.texts.notifications.title') }}
    </h1>
    <h2 class="primary--text">
      {{ $t('documentation.texts.notifications.alertCreate.title') }}
    </h2>
    <p>
      {{ $t('documentation.texts.notifications.alertCreate.paragraph1') }}
    </p>
    <v-img style="width: 100%; max-width: 900px" contain :src="pic1Name" />
    <p>
      {{ $t('documentation.texts.notifications.alertCreate.paragraph2') }}
    </p>
    <v-img style="width: 100%; max-width: 600px" contain :src="pic2Name" />
    <p>
      {{ $t('documentation.texts.notifications.alertCreate.paragraph3') }}
    </p>
    <v-img style="width: 100%; max-width: 600px" contain :src="pic3Name" />
  </v-col>
</template>

<script>
export default {
  computed: {
    pic1Name() {
      return require('@/assets/documentation/notifications/' +
        this.$t('documentation.texts.notifications.alertCreate.picBefore') +
        '.png')
    },
    pic2Name() {
      return require('@/assets/documentation/notifications/' +
        this.$t('documentation.texts.notifications.alertCreate.picDetail') +
        '.png')
    },
    pic3Name() {
      return require('@/assets/documentation/notifications/' +
        this.$t('documentation.texts.notifications.alertCreate.picHistory') +
        '.png')
    },
  },
  methods: {},
}
</script>

<style>
.custom-link {
  transition: 0.3s;
  cursor: pointer;
}
.custom-link:hover {
  text-decoration: underline;
}
</style>
